var _rect, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#D97706"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.728,60H11.272L-0.375,24h64.749L52.728,60z M12.728,58h38.545l10.353-32H2.375L12.728,58z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 4.23,
    transform: "matrix(0.9284 0.3715 -0.3715 0.9284 6.8601 -5.6132)",
    width: 2.001,
    height: 21.541,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.23,
    y: 14,
    transform: "matrix(0.3714 0.9285 -0.9285 0.3714 42.8432 -33.2808)",
    width: 21.541,
    height: 2.001,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 34,
    width: 2,
    height: 18,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 18,
    height: 2,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketAdd);
export default __webpack_public_path__ + "static/media/basket-add.146e34a38d982c72a31124eb2587fb2b.svg";
export { ForwardRef as ReactComponent };